export default __webpack_public_path__ + "static/media/horseRacingIcon.d09f4816.svg";